module.exports = __webpack_public_path__ + "img/o-d-user.1fc41beb.svg";